import React from "react";
import { fmtDate, fmtTime } from "@/lib/format";

const LABELS = {
  extracted: "Candidate extracted",
  reviewed: "Reviewed",
  approved: "Approved",
  published: "Published",
  revoked: "Revoked",
};

const DESCRIPTIONS = {
  revoked: "Artifact removed from publication targets; downstream artifacts frozen.",
  published: "Artifact released to its publication target with full evidence record.",
  approved: "Reviewer approved with evidence chain complete.",
  reviewed: "Reviewer opened and assessed the candidate.",
  extracted: "Candidate synthesized from source set; evidence record opened.",
};

const descriptionFor = (k) => DESCRIPTIONS[k] || DESCRIPTIONS.extracted;

export const EvidenceTimeline = ({ timestamps }) => {
  const entries = Object.entries(timestamps || {}).filter(([, v]) => v);
  return (
    <ol className="relative border-l border-border/80 ml-2 pl-6 space-y-6">
      {entries.map(([k, v], i) => (
        <li key={k} className="relative">
          <span className="absolute -left-[29px] top-1 h-2.5 w-2.5 rounded-full bg-brand border-2 border-background" />
          <div className="flex items-baseline gap-3">
            <span className="tracked-caps">{LABELS[k] || k}</span>
            <span className="font-mono text-xs text-muted-foreground">{fmtDate(v)} · {fmtTime(v)}</span>
          </div>
          <div className="mt-1 text-sm text-foreground/90">{descriptionFor(k)}</div>
          {i === entries.length - 1 && <div className="mt-4 hairline" />}
        </li>
      ))}
    </ol>
  );
};

export default EvidenceTimeline;
